import React from 'react';
// import {Portal} from 'react-portal';
// import ActionButton from '../../ui/ActionButton';
// import ToolboxMenuItem from '../../uiControls/ToolboxMenuItem';

// import {ReactComponent as ShortcutIcon} from "../../img/shortcut-blue.svg";

function ListViewShortcutMenu() {
  return null;
  // return (
  //   <Portal node={document && document.getElementById('ifms-top-right-menu-placeholder')}>
  //       <div className="ifms-list-shortcut" data-tooltip="Shortcut" data-tooltip-position="right">
  //         <ActionButton
  //           action="hover"
  //           type="primaryInverse"
  //           size="large"
  //           hideCaret
  //           items={[
  //             { label: <ToolboxMenuItem label="New" shortcut="F2" />, separator: false, fkey: 'F2' },
  //             { label: <ToolboxMenuItem label="Edit" shortcut="F3" />, separator: false, fkey: 'F3' },
  //             { label: <ToolboxMenuItem label="View" shortcut="F9" />, separator: false, fkey: 'F9' },
  //             { label: <ToolboxMenuItem label="Copy" shortcut="Ctrl+F2" />, separator: false, fkey: 'Ctrl+F2' },
  //             { label: <ToolboxMenuItem label="Search" shortcut="F5" />, separator: false, fkey: 'F5' },
  //             { label: <ToolboxMenuItem label="Switch to HBL" shortcut="F6" />, separator: false, fkey: 'F6' },
  //             { label: <ToolboxMenuItem label="Memo" shortcut="F8" />, separator: false, fkey: 'F8' },
  //             { label: <ToolboxMenuItem label="Refresh" shortcut="F11" />, separator: false, fkey: 'F11' },
  //             { label: <ToolboxMenuItem label="Help" shortcut="F1" />, separator: false, fkey: 'F1' },
  //           ]}
  //           onItemSelected={item => {
  //             window.console.log(item);
  //           }}
  //         >
  //           <ShortcutIcon width={20} height={20} />
  //         </ActionButton>
  //       </div>
  //     </Portal>
  // );
}
export default React.memo(ListViewShortcutMenu);